import { useFeedbackActions } from "widgets/feedback-button/model/useFeedbackActions"

import { FeedbackActionsOverlayModel } from "../FeedbackActionsOverlay"
import { FeedbackActionsOverlayViewModel } from "../FeedbackActionsOverlayView"

export function useFeedbackActionsOverlayViewModel({
  onClose,
  onOpenFeedbackMessageOverlay
}: FeedbackActionsOverlayModel): FeedbackActionsOverlayViewModel {
  const feedbackActions = useFeedbackActions(onOpenFeedbackMessageOverlay)

  return { feedbackActions, onCancel: onClose }
}
